import { Chip } from '@mui/material';
import { Stack } from '@mui/system';
import { CustomCellRendererProps } from 'ag-grid-react';
import { FC } from 'react';

export const BuyingEventCategoriesRenderer: FC<CustomCellRendererProps> = ({ value }) => {
    return (
        <Stack direction="row" spacing={1} sx={{ height: 1, alignItems: 'center' }}>
            {value?.map((category: string) => (
                <Chip key={category} label={category} size="small" variant="outlined" />
            ))}
        </Stack>
    );
};
